<template>
  <div class="__wrap">
    <textarea 
      class="__textarea" 
      v-model="valueInput"
    >
    </textarea>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      valueInput: this.value
    }
  },

  watch: {
    valueInput: {
      handler: function() {
        this.$emit('value', this.valueInput)
      },
      deep: true
    }
  }
};
</script>

<style scoped lang="scss">
.__wrap {
  display: flex;
  flex-direction: row;
  width: 100%;
  overflow: hidden;
  box-sizing: border-box;
  border-radius: 4px;
  border: 1px solid #dddddd !important;
  padding: 12px 16px;
}
.__textarea {
  width: 100%;
  min-height: calc(3rem + 0.5rem);

  background: #ffffff;

  box-sizing: border-box;
  border-radius: 4px;
  outline: 0;
  overflow: hidden;
}
</style>